import React from 'react'

class Paging extends React.Component {
    render() {
        const { data, pageCont } = this.props
        const cp = parseInt(data.currPage, 10)
        let currBlk = (cp - 1) / data.blockPage
        currBlk = parseInt(currBlk, 10) * data.blockPage + 1
        const bCnt = data.totalPage < data.blockPage ? data.totalPage : data.blockPage
        const pblk = []
        for (let i = 0; i < bCnt; i += 1) {
            if (currBlk + i - 1 < data.totalPage) pblk.push(currBlk + i)
        }
        return (
            <div className="paging">
                {currBlk > data.blockPage && (
                    <React.Fragment>
                        <button type="button" className="btn_paging_first pbt" onClick={e => pageCont(e, 1)}>
                            <i className="icon-angle-double-left" /> 처음
                        </button>
                        <button
                            type="button"
                            className="btn_paging_prev pbt"
                            onClick={e => pageCont(e, cp - data.blockPage)}
                        >
                            <i className="icon-angle-left" /> 이전
                        </button>
                    </React.Fragment>
                )}
                {pblk.map((v, i) => {
                    const acCls = cp === v ? 'active pbt' : 'inactive pbt'
                    const key = i
                    return (
                        <button type="button" key={key} onClick={e => pageCont(e, v)} className={acCls}>
                            {v}
                        </button>
                    )
                })}
                {currBlk + data.blockPage < data.totalPage && (
                    <React.Fragment>
                        <button
                            type="button"
                            className="btn_paging_next pbt"
                            onClick={e => pageCont(e, cp + data.blockPage)}
                        >
                            다음 <i className="icon-angle-right" />
                        </button>
                        <button
                            type="button"
                            className="btn_paging_last pbt"
                            onClick={e => pageCont(e, data.totalPage)}
                        >
                            끝 <i className="icon-angle-double-right" />
                        </button>
                    </React.Fragment>
                )}
            </div>
        )
    }
}
export default Paging
